import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-numbered-list-section',
  imports: [CommonModule, FormsModule, TranslatePipe],
  templateUrl: './numbered-list-section.html',
  styleUrl: './numbered-list-section.css',
})
export class NumberedListSection {

  @Input() items: string[] = [];
  @Input() editable = false;

  newItem = '';

  addItem(): void {
    if (!this.newItem.trim()) return;

    this.items.push(this.newItem);
    this.newItem = '';
  }

  removeItem(index: number): void {
    this.items.splice(index, 1);
  }
}